import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    // httpOnly session cookie is set by server; CSRF cookie is readable from JS.
    // v109.9.120 — Also refetch /auth/me to be extra-defensive: guarantees the
    // just-logged-in user carries fully-resolved `granted_modules*` +
    // `effective_permissions` even if a legacy login response is ever thin.
    setUser(data.user);
    try {
      const me = await api.get("/auth/me");
      setUser(me.data);
    } catch { /* keep login payload */ }
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      // proceed even if logout call fails
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
